import { Instagram, Youtube, Twitter } from "lucide-react";

const SpotifyIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22zm5.05 15.85c-.2.33-.62.44-.95.24-2.6-1.59-5.87-1.95-9.73-1.07-.37.09-.74-.14-.83-.51-.09-.37.14-.74.51-.83 4.22-.96 7.91-.55 10.79 1.23.33.2.44.61.24.94l-.03.0zm1.35-3c-.25.4-.78.53-1.18.28-2.97-1.83-7.5-2.36-11-1.29-.46.14-.94-.12-1.08-.58-.14-.46.12-.94.58-1.08 4.01-1.21 9.01-.62 12.4 1.51.4.25.53.78.28 1.16zm.12-3.12C14.93 8.56 11.9 8.3 8.55 9.26c-.53.16-1.08-.14-1.24-.67-.16-.53.14-1.08.67-1.24 3.83-1.1 7.32-.78 10.62.88.5.25.66.85.41 1.35-.25.49-.85.65-1.34.4l-.2-.25z" />
  </svg>
);

const SoundCloudIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
    <path d="M2.5 14.5v4M5 13v6M7.5 11v8.5M10 9v10.5" />
    <path d="M10 19.5h8.5a3.75 3.75 0 0 0 .8-7.4A6 6 0 0 0 10 9.4" fill="none" />
  </svg>
);

// PLACEHOLDER: replace `href: null` with the label's official profile URLs when provided,
// and switch the <button> below back to <a href target="_blank" rel="noopener noreferrer">.
export const SOCIALS = [
  { id: "instagram", label: "Instagram", href: null, Icon: Instagram },
  { id: "youtube", label: "YouTube", href: null, Icon: Youtube },
  { id: "spotify", label: "Spotify", href: null, Icon: SpotifyIcon },
  { id: "soundcloud", label: "SoundCloud", href: null, Icon: SoundCloudIcon },
  { id: "x", label: "X (Twitter)", href: null, Icon: Twitter },
];

export const SocialIcons = ({ className = "", iconClassName = "" }) => (
  <div className={`flex items-center gap-1 ${className}`} data-testid="social-icons">
    {SOCIALS.map(({ id, label, Icon }) => (
      <button
        key={id}
        type="button"
        disabled
        title={`${label} — link coming soon`}
        aria-label={`${label} (link coming soon)`}
        className={`relative p-2 text-ice/35 cursor-not-allowed group/soc ${iconClassName}`}
        data-testid={`social-link-${id}`}
      >
        <Icon size={16} />
        <span className="pointer-events-none absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md bg-charcoal border border-crystal/40 px-2 py-1 font-mono text-[9px] uppercase tracking-[0.15em] text-ice/70 opacity-0 group-hover/soc:opacity-100 transition-opacity duration-200">
          Coming soon
        </span>
      </button>
    ))}
  </div>
);
